module.exports = __webpack_public_path__ + "static/media/wheatFlour.8e26559f.png";